import { ArrowDownRight, MapPin, CalendarDays } from "lucide-react";
import { PLAYER, MEDIA, EVENT } from "@/lib/content";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden pt-16"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${MEDIA.hero})` }}
        aria-hidden
      />
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#09090B] via-transparent to-transparent" />

      {/* Diagonal stripe */}
      <div className="absolute bottom-0 left-0 right-0 h-2 diagonal-bar opacity-90" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.35em] text-[#00E5FF] mb-6">
          <span className="h-2 w-2 bg-[#FF007F] animate-pulse" />
          Wookies • #{PLAYER.jersey} • {PLAYER.position}
        </div>

        <h1 className="font-display uppercase leading-[0.85] tracking-tighter text-[16vw] md:text-[12vw] lg:text-[9.5vw]">
          Send <span className="text-[#FF007F]">Camden</span>
          <br />
          <span className="text-white">to the</span>{" "}
          <span className="relative inline-block">
            <span className="text-[#FACC15]">NATTYS.</span>
            <span className="absolute -bottom-2 left-0 right-0 h-1 bg-[#00E5FF] shadow-cyan-glow" />
          </span>
        </h1>

        {/* Event details strip */}
        <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 items-center text-sm md:text-base text-[#D4D4D8]">
          <div className="inline-flex items-center gap-2">
            <CalendarDays className="h-5 w-5 text-[#00E5FF]" />
            <span className="font-semibold">{EVENT.dates}</span>
          </div>
          <div className="inline-flex items-center gap-2">
            <MapPin className="h-5 w-5 text-[#FF007F]" />
            <span className="font-semibold">{EVENT.city}</span>
            <span className="text-[#71717A]">• {EVENT.venue}</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#FACC15] border-l border-[#27272A] pl-4">
            {EVENT.tagline}
          </div>
        </div>

        <div className="mt-8 max-w-2xl">
          <p className="text-lg md:text-xl text-[#E4E4E7] font-light leading-relaxed">
            {PLAYER.shortBio}
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-4 items-center">
          <a
            href="#donate"
            data-testid="hero-donate-cta"
            className="inline-flex items-center gap-3 bg-[#FF007F] text-white px-8 py-4 font-bold uppercase tracking-[0.2em] hover:-translate-y-1 transition-transform shadow-pink-glow"
          >
            Send him to Mesa
            <ArrowDownRight className="h-5 w-5" />
          </a>
          <a
            href="#story"
            className="inline-flex items-center gap-2 px-6 py-4 border border-[#27272A] text-white font-bold uppercase tracking-[0.2em] hover:border-white transition-colors"
          >
            Read his story
          </a>
        </div>
      </div>

      {/* Marquee word strip */}
      <div className="absolute bottom-6 left-0 right-0 overflow-hidden pointer-events-none z-0 opacity-40">
        <div className="marquee-track whitespace-nowrap font-display text-[16vw] md:text-[10vw] uppercase tracking-tighter text-white/10">
          <span className="mr-12">Native American Nationals</span>•
          <span className="mx-12">Mesa AZ • June 2026</span>•
          <span className="mx-12">29 courts</span>•
          <span className="mx-12">Native American Nationals</span>•
          <span className="mx-12">Mesa AZ • June 2026</span>•
          <span className="mx-12">29 courts</span>•
        </div>
      </div>
    </section>
  );
}
